<div class="full-height layout-column timecards-table" appBringozIdGenerator="timecards-table">

  @let cols = columns();

  <bz-table class="flex"
            uniqueId="timecards-table"
            idField="rowId"
            [rowHeight]="50"
            [headerHeight]="50"
            [resizable]="true"
            [defaultWidths]="defaultWidths"
            [settings]="tableSettings()"
            [items]="flattenedRows()"
            [isLoading]="loading()"
            (settingsChange)="tableSettingsChange.emit($event)"
            (fetchNext)="onFetchNext()">

    <ng-template bzTableHeader>
      <div class="layout-row layout-align-start-center th col-name">
        <bz-checkbox size="sm"
                     appBringozIdGenerator="timecards-select-all-checkbox"
                     [disabled]="!flattenedRows().length"
                     [checked]="allSelected()"
                     [indeterminate]="headerIndeterminate()"
                     [ariaLabel]="'Select All' | translate"
                     (checkedChange)="onToggleSelectAll()">
        </bz-checkbox>
        <span class="br-body-1 font-weight-600 gray-100">{{ 'Employee' | translate }}</span>
      </div>
      @if (cols?.status?.enabled) {
        <div class="th col-status layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Status' | translate }}</span>
        </div>
      }
      @if (cols?.employeeId?.enabled) {
        <div class="th col-employeeId layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Employee ID' | translate }}</span>
        </div>
      }
      @if (cols?.employeeZip?.enabled) {
        <div class="th col-employeeZip layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Employee Zip' | translate }}</span>
        </div>
      }
      @if (cols?.jobTitle?.enabled) {
        <div class="th col-jobTitle layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Job Title' | translate }}</span>
        </div>
      }
      @if (cols?.branch?.enabled) {
        <div class="th col-branch layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Branch' | translate }}</span>
        </div>
      }
      @if (cols?.distance?.enabled) {
        <div class="th col-distance layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Distance' | translate }}</span>
        </div>
      }
      @if (cols?.mph?.enabled) {
        <div class="th col-mph layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'MPH' | translate }}</span>
        </div>
      }
      @if (cols?.serviceTime?.enabled) {
        <div class="th col-serviceTime layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Service Time' | translate }}</span>
        </div>
      }
      @if (cols?.driveTime?.enabled) {
        <div class="th col-driveTime layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Drive Time' | translate }}</span>
        </div>
      }
      @if (cols?.adminTime?.enabled) {
        <div class="th col-adminTime layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Admin Time' | translate }}</span>
        </div>
      }
      @if (cols?.pto?.enabled) {
        <div class="th col-pto layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'PTO' | translate }}</span>
        </div>
      }
      @if (cols?.paidTime?.enabled) {
        <div class="th col-paidTime layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Paid Time' | translate }}</span>
        </div>
      }
      @if (cols?.plannedTime?.enabled) {
        <div class="th col-plannedTime layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Planned Time' | translate }}</span>
        </div>
      }
      @if (cols?.stops?.enabled) {
        <div class="th col-stops layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Stops' | translate }}</span>
        </div>
      }
      @if (cols?.break?.enabled) {
        <div class="th col-break layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Break' | translate }}</span>
        </div>
      }
      @if (cols?.off?.enabled) {
        <div class="th col-off layout-row layout-align-start-center">
          <span class="br-body-1 font-weight-600 gray-100">{{ 'Off' | translate }}</span>
        </div>
      }
    </ng-template>

    <ng-template bzTableRow let-row>
      @if (row.type === 'parent') {
        <!-- Parent Row (TimeCard Group - Agent Summary) -->
        <timecard-table-row [group]="row.group"
                            [index]="row.index"
                            [isExpanded]="row.isExpanded"
                            [columns]="cols"
                            [isSelected]="groupSelectedMap()[row.group?.id]"
                            [isIndeterminate]="groupIndeterminateMap()[row.group?.id]"
                            (timecardSelect)="onSelectTimecard($event.timecard, $event.group, true)"
                            (expandToggle)="onToggleExpand($event)"
                            (selectToggle)="onToggleGroupSelect($event)">
        </timecard-table-row>
      } @else {
        <!-- Child Row (Individual TimeCard - Shift/Day) -->
        <timecard-entry-row [timecard]="row.timecard"
                            [dayName]="row.dayName"
                            [group]="row.group"
                            [index]="row.index"
                            [isLastChild]="row.isLastChild"
                            [columns]="cols"
                            [date]="row.date"
                            [isSelected]="selectedTimecardKeys()[row.timecard?.id]"
                            (timecardSelect)="onSelectTimecard($event.timecard, $event.group, false, $event.date)"
                            (selectToggle)="onToggleTimecardSelect($event)">
        </timecard-entry-row>
      }
    </ng-template>

    <bz-empty-state bzTableEmptyState [title]="'No timecards found' | translate"></bz-empty-state>
  </bz-table>

</div>
